module.exports = __webpack_public_path__ + "img/empty-state-users.7fdffeae.png";